<div class="bottom-sheet">
  <div *ngIf="data.headerTemplate" class="header">
    <ng-container *ngTemplateOutlet="data.headerTemplate"></ng-container>
  </div>
  <div>
    <ng-container *ngTemplateOutlet="data.contentTemplate"></ng-container>
  </div>
</div>
